import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { Emoji } from '@atlaskit/editor-common/emoji';

// eslint-disable-next-line
var clickSelectWrapperStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage\n\tuser-select: all;\n"])));
export default function EmojiNode(props) {
  return jsx("span", {
    css: clickSelectWrapperStyle
  }, jsx(Emoji
  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  , props));
}